import { Suspense } from "solid-js";
import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";

import Nav from "~/components/Nav";
import "~/_assets/genie-dashboard.css";


export default function App() {
	return (
		<Router
			root={props => (
				<>
					<div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
						<Nav />
					</div>

					<div class="lg:pl-72">
						<div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8">
							<button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden">
								<span class="sr-only">Open sidebar</span>
								<svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
									<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
								</svg>
							</button>

							<div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true"></div>

							<div id="search-bar" >
							</div>
						</div>

						<main class="p-10">
							<Suspense fallback={<div>Loading...</div>}>
								{props.children}
							</Suspense>
						</main>
					</div>
				</>
			)}
		>
			<FileRoutes />
		</Router>
	);
}
